import { readQueryParamNumber } from "/Helpers/readQueryParam";
import BaseSearchClient, { BaseListResult } from "/Helpers/BaseSearchClient";
import { NewsListFilters } from "./NewsListPage";

export interface NewsListResults extends BaseListResult {}
export default class NewsListClient extends BaseSearchClient {
  public GetItems = ({
    ...props
  }: NewsListFilters): Promise<NewsListResults> => {
    const { pageNumber } = props;
    return fetch(
      `${this.endpoint}?page=${pageNumber}&language=${this.language}&newsListPageId=${this.pageId}`,
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error from event list API");
        }
        return response.json();
      })
      .catch((error) => {
        //gracefull return
        return { error: true, message: error.message };
      });
  };

  public BuildUrlFromProps = ({
    ...props
  }: NewsListFilters): string | undefined => {
    const { pageNumber } = props;
    if (this._baseUrl) return `${this._baseUrl}?page=${pageNumber}`;
  };

  private GetPageNumberFromUrl = (): number =>
    readQueryParamNumber("page") ?? 1;

  public GetParams = () => {
    return {
      pageNumber: this.GetPageNumberFromUrl(),
    };
  };
}
